import Mock from 'mockjs'
// mock需要给三个参数,url(与axios请求是传的url一致,我这个是本地启动的项目就直接用本地域名了)
// 请求类型: get post...其他看文档
// 数据处理函数,函数需要return数据
Mock.mock(/Starter\/deposit/, 'get', () => {
  let data={
            "status": 1000,
            "data": {
              "endDate": "1648857600000",
              "maxDeposit": 4000.0,
              "totalDeposited": 9999,
              "deposited": false,
              "offerAddress": "0x802A285f6eE8CBC7772f803D7f7Dd22f01769c43",
              "isEth":false,
              "vestingPeriod": "25% TGE, 25% Linear Monthly",
              "medium": "https://medium.com/@enrex",
              "tips": null,
              "claimType": 2,
              "yourShare": 4.762,
              "twitter": "https://twitter.com/enrex_crypto",
              "startDateS": "31-03-2022 08:00",
              "hasRoot": true,
              "chainID": 56,
              "price": 0.007,
              "rTokenDecimals": 18,
              "details": "DeFi gateway to multibillion dollar carbon allowances and renewable energy certificates markets. It is a platform which delivers the ultimate promise of easing the transition for crypto businesses to an eco-friendlier trajectory. Enrex will be offering both consumers and financial instrument issuing authorities an easy-to-use application set to deepen their pledge for a greener environment.",
              "minDeposit": 100.0,
              "endDateS": "02-04-2022 08:00",
              "earnToken": "ENRX",
              "depositPeriod": 2880,
              "maxDepositAvailable": 4000.0,
              "nowDate": 1649195953835,
              "harvestDate": 0,
              "website": "https://enrex.io/",
              "depositTokenLogo": "https://enrex.io/",
              "rtokenExplorer": "https://solscan.io/token/5s4BYUXLuvs9ZcVDTxkTpKhThWFSpaU8GG55q2iySe2N",
              "rtokenReal": "5s4BYUXLuvs9ZcVDTxkTpKhThWFSpaU8GG55q2iySe2N",
              "telegram": "https://t.me/enrex_community",
              "isEnd": true,
              "totalRewards": 12000000,
              "depositToken": "USDT",
              "rAddress": "0x7DC2Ef04424Bd9689bD3970181177be892939E91",
              "dAddress": "0x55d398326f99059fF775485246999027B3197955",
              "dTokenDecimals": 18,
              "objectName": "Enrex",
              "progress": 100.00,
              "isFull": true,
              "startDate": "1648684800000",
              "ratio": 35.7142
            }
          };
  return data;
})



// WEBPACK FOOTER //
// ./src/mock/index.js